export default __webpack_public_path__ + "static/media/about-2.6dbcf7a3.png";